import React, { useState, useEffect } from "react";
import instance from "../../instance";

import "../Customer.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppInformation = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");

  const [appData, setAppData] = useState(null);
  const [isEditingApp, setIsEditingApp] = useState(false);
  const [showPasswordAdmin, setShowPasswordAdmin] = useState(false);
  const [showSuperAdmin, setShowSuperAdmin] = useState(false);
  const [appFormData, setAppFormData] = useState({
    VersionBack: "",
    VersionFront: "",
    UrlFront: "",
    UrlBack: "",
    SuperAdmin: "",
    PasswordSuperAdmin: "",
  });

  useEffect(() => {
    if (code) {
      fetchAppData();
    } else {
      toast.error("No code provided.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchAppData is recreated each render; adding it would refetch on every paint
  }, [code]);

  const fetchAppData = async () => {
    try {
      const response = await instance.get(`app/by-code/${code}`);
      if (response.status !== 200) {
        throw new Error("Failed to fetch app data.");
      }
      const data = response.data;
      if (data && data.data) {
        setAppData(data.data);
        setAppFormData({
          VersionBack: data.data.VersionBack || "",
          VersionFront: data.data.VersionFront || "",
          UrlFront: data.data.UrlFront || "",
          UrlBack: data.data.UrlBack || "",
          SuperAdmin: data.data.SuperAdmin || "",
          PasswordSuperAdmin: data.data.PasswordSuperAdmin || "",
        });
      } else {
        toast.error("No App data found for the given code.");
      }
    } catch (error) {
      console.error("Error fetching app data:", error);
      toast.error("An error occurred while fetching app data.");
    }
  };

  const toggleEditApp = () => {
    if (isEditingApp) {
      saveAppData();
    } else {
      setIsEditingApp(true);
    }
  };

  const handleAppInputChange = (event) => {
    const { id, value } = event.target;
    setAppFormData({ ...appFormData, [id]: value });
  };

  const saveAppData = async () => {
    try {
      const response = await instance.put(`app/by-code/${code}`, appFormData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success("App details updated successfully!");
      fetchAppData();
      setIsEditingApp(false);
    } catch (error) {
      console.error("Error updating app details:", error);
      toast.error("An error occurred while updating app details.");
    }
  };

  const togglePasswordAdminVisibility = () => {
    setShowPasswordAdmin(!showPasswordAdmin);
  };

  const toggleSuperAdminVisibility = () => {
    setShowSuperAdmin(!showSuperAdmin);
  };

  return (
    <div>
      <main>
        <section id="app-section">
          <h2>App Information</h2>
          {appData && (
            <ul>
              <li>
                Version Back:{" "}
                <span
                  className={`info ${isEditingApp ? "hidden" : ""}`}
                  id="info-VersionBack"
                >
                  {appData.VersionBack}
                </span>
                {isEditingApp && (
                  <input
                    className="input-field"
                    type="text"
                    id="VersionBack"
                    value={appFormData.VersionBack}
                    onChange={handleAppInputChange}
                    placeholder="Enter Version Back"
                  />
                )}
              </li>
              <li>
                Version Front:{" "}
                <span
                  className={`info ${isEditingApp ? "hidden" : ""}`}
                  id="info-VersionFront"
                >
                  {appData.VersionFront}
                </span>
                {isEditingApp && (
                  <input
                    className="input-field"
                    type="text"
                    id="VersionFront"
                    value={appFormData.VersionFront}
                    onChange={handleAppInputChange}
                    placeholder="Enter Version Front"
                  />
                )}
              </li>
              <li>
                Url Front:{" "}
                <span
                  className={`info ${isEditingApp ? "hidden" : ""}`}
                  id="info-UrlFront"
                >
                  <a
                    href={appData.UrlFront}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {appData.UrlFront}
                  </a>
                </span>
                {isEditingApp && (
                  <input
                    className="input-field"
                    type="text"
                    id="UrlFront"
                    value={appFormData.UrlFront}
                    onChange={handleAppInputChange}
                    placeholder="Enter Url Front"
                  />
                )}
              </li>
              <li>
                Url Back:{" "}
                <span
                  className={`info ${isEditingApp ? "hidden" : ""}`}
                  id="info-UrlBack"
                >
                  <a
                    href={appData.UrlBack}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {appData.UrlBack}
                  </a>
                </span>
                {isEditingApp && (
                  <input
                    className="input-field"
                    type="text"
                    id="UrlBack"
                    value={appFormData.UrlBack}
                    onChange={handleAppInputChange}
                    placeholder="Enter Url Back"
                  />
                )}
              </li>
              <li>
                Super Admin:{" "}
                <span
                  className={`info3 ${isEditingApp ? "hidden" : ""}`}
                  id="info-SuperAdmin"
                >
                  {showSuperAdmin ? appData.SuperAdmin : "••••••••"}
                </span>
                {isEditingApp && (
                  <input
                    className="input-field"
                    type={showSuperAdmin ? "text" : "password"}
                    id="SuperAdmin"
                    value={appFormData.SuperAdmin}
                    onChange={handleAppInputChange}
                    placeholder="Enter Super Admin"
                  />
                )}
                <button className="show" onClick={toggleSuperAdminVisibility}>
                  {showSuperAdmin ? "Hide" : "Show"}
                </button>
              </li>
              <li>
                Password Super Admin:{" "}
                <span
                  className={`info3 ${isEditingApp ? "hidden" : ""}`}
                  id="info-PasswordSuperAdmin"
                >
                  {showPasswordAdmin ? appData.PasswordSuperAdmin : "••••••••"}
                </span>
                {isEditingApp && (
                  <input
                    className="input-field"
                    type={showPasswordAdmin ? "text" : "password"}
                    id="PasswordSuperAdmin"
                    value={appFormData.PasswordSuperAdmin}
                    onChange={handleAppInputChange}
                    placeholder="Enter Password Super Admin"
                  />
                )}
                <button
                  className="show"
                  onClick={togglePasswordAdminVisibility}
                >
                  {showPasswordAdmin ? "Hide" : "Show"}
                </button>
              </li>
            </ul>
          )}
          <button className="edit-button" onClick={toggleEditApp}>
            {isEditingApp ? "Save" : "Update"}
          </button>
        </section>
      </main>
    </div>
  );
};

export default AppInformation;
